import { gql } from "@apollo/client";
import {
  FEED_CURVE_FRAGMENT,
  FeedCurve,
} from "../../FeedDataCalls/GQLCalls/getFeedCurvesCall";
import { MilestoneInfo } from "../../MilestoneDataCalls/GQLCalls/getMilestonesCall";

export const PANEL_ANIMAL_FRAGMENT = gql`
  fragment AnimalFields on AnimalInfo {
    animal_id
    location_id
    animal_number
    cycle
    correction
    feedcurve_id
    feedcurve_milestones
    milestone_day
    condition
    animal_type
    responder_number
    life_number
    deleted (domain: $domain)
    birthday
    animalGroup {
      groupId
      name
    }
    milestone {
      name
      milestone_id
    }
    consumptions(domain: $domain) @skip(if: $ifSkipConsumption) {
      progressed: consumed
      total: dayTotal
      milestoneDayOffset
    }
    lastTenDay: consumptions(
      domain: $domain
      amountOfDays: 10
      milestoneDayOffset: 0
    ) @skip(if: $ifSkipLastTenDaysConsumption) {
      progressed: consumed
      total: dayTotal
      milestoneDayOffset
    }
    feedCurve(domain: $domain) {
      ...FeedCurveFields
    }
    system(domain: $domain)
    event(domain: $domain) {
      timestamp
      eventNo: animal_event_id
      eventName: event_name
      note
    }
  }
  ${FEED_CURVE_FRAGMENT}
`;

export const GET_ANIMALS_INFO = gql`
  query GetAnimalInfo(
    $domain: String!
    $input: BasicQueryInfoInput!
    $idIdentifier: String
    $ifFeedCurveBaseInfoOnly: Boolean!
    $ifFeedCurveInfo: Boolean!
    $ifSpreading: Boolean!
    $ifSkipConsumption: Boolean!
    $ifSkipLastTenDaysConsumption: Boolean!
  ) {
    animal {
      info(domain: $domain, input: $input, idIdentifier: $idIdentifier) {
        ...AnimalFields
      }
    }
  }
  ${PANEL_ANIMAL_FRAGMENT}
`;

export type AnimalInfo = {
  animal_id: number;
  location_id?: number;
  animal_number: number;
  cycle: number;
  correction?: number;
  feedcurve_id?: number;
  feedcurve_milestones?: number;
  milestone_day?: number;
  condition?: number;
  animal_type?: number;
  responder_number?: string;
  life_number?: number;
  deleted?: boolean;
  birthday?: number;
  animalGroup: {
    groupId?: number;
    name?: string;
  };
  consumptions?: Consumption[];
  lastTenDay?: Consumption[];
  milestone?: Omit<MilestoneInfo, "deleted">;
  feedCurve?: FeedCurve;
  system?: string;
  event?: AnimalEvent[]
};

export interface AnimalEvent {
  timestamp: string
  eventNo: number
  eventName: string
  note?: string
}

export interface Consumption {
  progressed?: number;
  total?: number;
  milestoneDayOffset?: number;
}

export interface AnimalResponse {
  animal: {
    info: AnimalInfo[];
  }
}
